import { atom } from 'jotai'

export const placeNameAtom = atom('')
